import { render, staticRenderFns } from "./base-modal-setting.component.vue?vue&type=template&id=a936db68"
import script from "./base-modal-setting.component.vue?vue&type=script&lang=js"
export * from "./base-modal-setting.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports